// All channels data - including FIFA World Cup channels from the second file

export const initialChannels = [
  // Welcome / Promo
  {
    id: 1,
    name: 'Welcome to PlayZ TV',
    cat: 'entertainment',
    icon: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgyniKyW9pUz1OKx5bgzLASwGVSuP0e7hX9FxVMTJMHxhu8X0tpucgSplBZgM8pCYrJJH0P2_dTC1-wzp4mMUU4sKnOzghGPCwWdbYOOa4jTyhpr7ydNj-UK-bc56IMsk2H3WZJ-SzSZIk0dTpyABCFR2_zjC2_c86W1pv7odFBT_Y-hyJs62g-3zCJkPGd/s1024/1000398131.png',
    desc: 'PlayZ TV Promo',
    url: 'https://1nyaler.streamhostingcdn.top/stream/23/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 1234
  },
  
  // ===== FIFA WORLD CUP CHANNELS (from second file) =====
  {
    id: 2,
    name: 'Sports (FIFA WC)',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026 Live',
    url: 'https://1nyaler.streamhostingcdn.top/stream/94/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 400
  },
  // {
  //   id: 3,
  //   name: 'Bein Sports 1 Max Arabic',
  //   cat: 'worldcup',
  //   icon: '📺',
  //   desc: 'FIFA World Cup 2026 - Arabic',
  //   url: 'http://starhub.pro/live/farhat-3379/67897-913379/744517.ts',
  //   type: 'hls',
  //   status: 'live',
  //   viewers: 520
  // },
  // {
  //   id: 4,
  //   name: 'T Sports HD',
  //   cat: 'worldcup',
  //   icon: '📺',
  //   desc: 'FIFA World Cup 2026 - HD',
  //   url: 'http://rgkkw.live/live/1Aoen7elp5/IgMJ60tmAa/130714.ts',
  //   type: 'hls',
  //   status: 'live',
  //   viewers: 890
  // },
  // {
  //   id: 5,
  //   name: 'Unite 8 Sports 1 HD Hindi',
  //   cat: 'worldcup',
  //   icon: '📺',
  //   desc: 'FIFA World Cup 2026 - Hindi',
  //   url: 'http://starhub.pro/live/farhat-3379/67897-913379/741567.ts',
  //   type: 'hls',
  //   status: 'live',
  //   viewers: 230
  // },
  {
    id: 6,
    name: 'Bein Sports Direct',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026 Direct',
    url: 'https://1nyaler.streamhostingcdn.top/stream/23/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 290
  },
  {
    id: 7,
    name: 'TPV Sport',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026',
    url: 'https://1nyaler.streamhostingcdn.top/stream/89/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 180
  },
  // {
  //   id: 8,
  //   name: 'Bein Sports',
  //   cat: 'worldcup',
  //   icon: '📺',
  //   desc: 'FIFA World Cup 2026',
  //   url: 'http://ua.online24.pm/play/1101/350B326FB34F4B8/video.m3u8',
  //   type: 'hls',
  //   status: 'live',
  //   viewers: 520
  // },
  {
    id: 9,
    name: 'Win Sports',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026',
    url: 'https://1nyaler.streamhostingcdn.top/stream/32/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 170
  },
  {
    id: 10,
    name: 'D Sports',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026',
    url: 'https://1nyaler.streamhostingcdn.top/stream/106/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 210
  },
  {
    id: 11,
    name: 'Bein Sports Tekrar',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026 Replay',
    url: 'https://ua.online24.pm/play/1103/350B326FB34F4B8/video.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 110
  },
  {
    id: 12,
    name: 'Somoy TV (FIFA)',
    cat: 'worldcup',
    icon: '📺',
    desc: 'FIFA World Cup 2026 - Somoy TV',
    url: 'https://live.thebosstv.com:30443/dwlive/Somoy-TV/playlist.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 340
  },

  // Additional Live Event channels
  {
    id: 13,
    name: '2nd Test - Day 2 - ENG vs NZ',
    cat: 'sports',
    icon: 'https://origin-staticv2.sonyliv.com/videoasset_images/manage_file/1000019569/1781260915712832_ENGvsNZ_2nd_test_day2_landscape_thumb.jpg',
    desc: 'New Zealand Tour of England 2026',
    url: 'https://sonydaimenew.akamaized.net/hls/live/20000291/criclive1806/ENG/std_lrh-800300010.m3u8?hdnea=exp=1781836574~acl=/*~id=98509200033141427991853088214574~hmac=d93e14716b62aba19a25a81ba26c69ab2decc658440efd01ba97509aa6f8890b',
    type: 'hls',
    status: 'live',
    viewers: 15420
  },
  {
    id: 14,
    name: 'Nigeria vs Hong Kong',
    cat: 'sports',
    icon: 'https://www.fancode.com/skillup-uploads/cms-media/143314_6124_NIG_HK_FC-WEB.jpg',
    desc: "Men's T20I Tri series in Namibia 2026",
    url: 'https://bd-mc-fblive.fancode.com/mumbai/143314_english_hls_0cf86887d237459_1ta-di_h264/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 8920
  },
  {
    id: 15,
    name: 'Jabalpur vs Nimar Eagles',
    cat: 'sports',
    icon: 'https://www.fancode.com/skillup-uploads/cms-media/143092_6102_JRL_RNG_FC-WEB.jpg',
    desc: 'MP League T20- 2026',
    url: 'https://bd-mc-fblive.fancode.com/mumbai/143092_english_hls_d606f94afb86483_1ta-di_h264/index.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 1800
  },

  // BDIX Toffee channels
  {
    id: 16,
    name: 'Sony Ten Sports 1 HD',
    cat: 'sports',
    icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/py5j-JQBv9knK3AHxDTY/posters/ea3358b9-2bec-4615-a889-daa2e396c74c.webp',
    desc: '[BD] Sony Ten Sports 1',
    url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/sony_sports_1_hd/playlist.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 3200
  },
  {
    id: 17,
    name: 'Sony Ten Sports 5 HD',
    cat: 'sports',
    icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/vi5n-JQBv9knK3AHqzTC/posters/d171fd4d-0369-4213-b0c5-e241974f5459.png',
    desc: '[BD] Sony Ten Sports 5',
    url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/sony_sports_5_hd/playlist.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 2100
  },
  {
    id: 18,
    name: 'Sony Ten Cricket',
    cat: 'sports',
    icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/ra2x_pQBrjBfS2_RWG9l/posters/795170c2-ec78-457e-9fa0-54a23d23361c.webp',
    desc: '[BD] Sony Ten Cricket',
    url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/ten_cricket/playlist.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 2800
  },
  {
    id: 19,
    name: 'Eurosport HD',
    cat: 'sports',
    icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/Uy6Q-JQBv9knK3AHcDUQ/posters/01709bcd-6d53-4710-a64f-bc49cecf1d61.webp',
    desc: '[BD] Eurosport HD',
    url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/euro_sports_hd/playlist.m3u8',
    type: 'hls',
    status: 'live',
    viewers: 1500
  },
//   {
//     id: 20,
//     name: 'CNN',
//     cat: 'news',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/VC6Q-JQBv9knK3AHhTXt/posters/63e79814-8fcf-4c3e-bb66-408b2a402613.webp',
//     desc: '[BD] CNN',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/cnn/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1200
//   },

//   // Bangla channels
//   {
//     id: 21,
//     name: 'Ekushey TV',
//     cat: 'news',
//     icon: 'https://s4.gifyu.com/images/image534fa27d7683f33d.png',
//     desc: 'Ekushey TV',
//     url: 'http://210.4.72.204/hls-live/livepkgr/_definst_/liveevent/livestream3.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 340
//   },
//   {
//     id: 22,
//     name: 'Deepto TV',
//     cat: 'entertainment',
//     icon: 'https://upload.wikimedia.org/wikipedia/en/3/31/Deepto_TV_logo.png',
//     desc: 'Deepto TV',
//     url: 'https://byphdgllyk.gpcdn.net/hls/deeptotv/0_1/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 290
//   },
//   {
//     id: 23,
//     name: 'BBC News',
//     cat: 'news',
//     icon: 'https://seeklogo.com/images/B/bbc-news-logo-8648ABD044-seeklogo.com.png',
//     desc: 'BBC News',
//     url: 'https://cdn4.skygo.mn/live/disk1/BBC_News/HLSv3-FTA/BBC_News-avc1_3000000=8-mp4a_208000_eng=2.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1800
//   },
//   {
//     id: 24,
//     name: 'Somoy TV',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1735560559088.png',
//     desc: 'Somoy TV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1702/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1340
//   },
//   {
//     id: 25,
//     name: 'Jamuna TV',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1735560213832.png',
//     desc: 'Jamuna TV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1701/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 890
//   },
//   {
//     id: 26,
//     name: 'NTV',
//     cat: 'entertainment',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1735560841094.png',
//     desc: 'NTV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1716/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1781
//   },
//   {
//     id: 27,
//     name: 'Channel I HD',
//     cat: 'entertainment',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1740567626692.png',
//     desc: 'Channel I HD',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1723/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 943
//   },
//   {
//     id: 28,
//     name: 'BTV',
//     cat: 'entertainment',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1778082545894.png',
//     desc: 'BTV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1709/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 410
//   },
//   {
//     id: 29,
//     name: 'Al Jazeera',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1777454219313.png',
//     desc: 'Al Jazeera',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1721/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 2678
//   },
//   {
//     id: 30,
//     name: 'Independent TV',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1778087037971.png',
//     desc: 'Independent TV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1704/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 310
//   },

//   // Sports channels
//   {
//     id: 31,
//     name: 'Star Sports 1',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/16-by-xfireflix.png',
//     desc: 'Star Sports 1',
//     url: 'https://cdn2.zohanayaan.com:1686/hls/star1in.m3u8?md5=pu72LOW5RZkINQmVxwbZeQ&expires=1781890816',
//     type: 'hls',
//     status: 'live',
//     viewers: 3800
//   },
//   {
//     id: 32,
//     name: 'PTV Sports',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/20-by-xfireflix.png',
//     desc: 'PTV Sports',
//     url: 'https://cdn3.zohanayaan.com:1686/hls/ptvpk.m3u8?md5=DZEpby01kStd5yWKYD-7mA&expires=1781890817',
//     type: 'hls',
//     status: 'live',
//     viewers: 1650
//   },
//   {
//     id: 33,
//     name: 'Willow HD',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/38-by-xfireflix.png',
//     desc: 'Willow HD',
//     url: 'https://cdn3.zohanayaan.com:1686/hls/willowusa.m3u8?md5=vdVXhO_KVrngZL54kTaqZw&expires=1781890817',
//     type: 'hls',
//     status: 'live',
//     viewers: 2900
//   },
//   {
//     id: 34,
//     name: 'Ten Sports',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/10-by-xfireflix.png',
//     desc: 'Ten Sports',
//     url: 'https://cdn9.zohanayaan.com:1686/hls/tenspk.m3u8?md5=-Ndy2-uf8RJY3CQiuh_mRA&expires=1781890817',
//     type: 'hls',
//     status: 'live',
//     viewers: 2200
//   },
//   {
//     id: 35,
//     name: 'A Sports HD',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/12-by-xfireflix.png',
//     desc: 'A Sports HD',
//     url: 'https://cdn5.zohanayaan.com:1686/hls/asportshd.m3u8?md5=08208MqDIlfVrzZVa7oH6Q&expires=1781890817',
//     type: 'hls',
//     status: 'live',
//     viewers: 980
//   },
//   {
//     id: 36,
//     name: 'Sky Sports Cricket',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/9-by-xfireflix.png',
//     desc: 'Sky Sports Cricket',
//     url: 'https://cdn9.zohanayaan.com:1686/hls/skyscric.m3u8?md5=EO1O17dzZMnrffLk9j7vhg&expires=1781890818',
//     type: 'hls',
//     status: 'live',
//     viewers: 1300
//   },
//   {
//     id: 37,
//     name: 'Sky Sports Main Event',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/18-by-xfireflix.png',
//     desc: 'Sky Sports Main Event',
//     url: 'https://cdn8.zohanayaan.com:1686/hls/skysme.m3u8?md5=M1hVy3xeDZt7OzP6Bk47og&expires=1781890818',
//     type: 'hls',
//     status: 'live',
//     viewers: 2000
//   },
//   {
//     id: 38,
//     name: 'ESPN 1',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/17-by-xfireflix.png',
//     desc: 'ESPN 1',
//     url: 'https://cdn7.zohanayaan.com:1686/hls/espnusa.m3u8?md5=koggjBmfV_s_cL-ejZnnwQ&expires=1781890822',
//     type: 'hls',
//     status: 'live',
//     viewers: 1500
//   },
//   {
//     id: 39,
//     name: 'ESPN 2',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/17-by-xfireflix.png',
//     desc: 'ESPN 2',
//     url: 'https://cdn9.zohanayaan.com:1686/hls/espn2.m3u8?md5=qJ3OqiUGAWc9Y5enX7Ra9Q&expires=1781890822',
//     type: 'hls',
//     status: 'live',
//     viewers: 980
//   },
//   {
//     id: 40,
//     name: 'Fox Cricket 501 HD',
//     cat: 'sports',
//     icon: 'https://abusaeeidx.github.io/Tv-Channel-Logo/CricHD/runded/6-by-xfireflix.png',
//     desc: 'Fox Cricket 501 HD',
//     url: 'https://cdn7.zohanayaan.com:1686/hls/fox501.m3u8?md5=tMtUB6B7iyRHiM7K1OkupQ&expires=1781890822',
//     type: 'hls',
//     status: 'live',
//     viewers: 1100
//   },
//   {
//     id: 41,
//     name: 'DD Sports',
//     cat: 'sports',
//     icon: 'https://s3.aynaott.com/storage/188500190395c4de0e506d518925dcc4',
//     desc: 'DD Sports',
//     url: 'https://cdn-6.pishow.tv/live/13/master.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 320
//   },
//   {
//     id: 42,
//     name: 'Sports Legends',
//     cat: 'sports',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1770377900139.png',
//     desc: 'Sports Legends',
//     url: 'https://nomawnoijl.gpcdn.net/akash/sportslegends/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 160
//   },
//   {
//     id: 43,
//     name: 'Flash Guys HD',
//     cat: 'sports',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1770378074527.png',
//     desc: 'Flash Guys HD',
//     url: 'https://nomawnoijl.gpcdn.net/akash/flashguys/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 120
//   },

//   // Entertainment channels
//   {
//     id: 44,
//     name: 'Sony MAX HD',
//     cat: 'entertainment',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/Ai51-JQBv9knK3AH_jWs/posters/663e52a6-1a9f-4458-b4aa-7c03d84972f1.webp',
//     desc: '[BD] Sony MAX HD',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/sony_max_hd/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1800
//   },
//   {
//     id: 45,
//     name: 'Sony PIX HD',
//     cat: 'entertainment',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/Ly6C-JQBv9knK3AHOjXt/posters/252e64ca-8d99-46e7-a951-e10c1703c11d.webp',
//     desc: '[BD] Sony PIX HD',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/sonypix_hd/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 1100
//   },
//   {
//     id: 46,
//     name: 'Zee Bangla Cinema',
//     cat: 'entertainment',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/-C7MX5UBv9knK3AHdKOi/posters/90d82846-70b9-44ee-9f7e-e440f00b3be8.png',
//     desc: '[BD] Zee Bangla Cinema',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/zee_bangla_cinema/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 540
//   },
//   {
//     id: 47,
//     name: 'Zee TV HD',
//     cat: 'entertainment',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/ltPQX5UBm1RY_In7b3F1/posters/d039d9df-9877-4969-a0b6-56888ebe2385.png',
//     desc: '[BD] Zee TV HD',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/zee_tv_hd/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 3100
//   },
//   {
//     id: 48,
//     name: 'Sony Entertainment Television',
//     cat: 'entertainment',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/2S5t-JQBv9knK3AHJTTW/posters/ae74f943-77c9-4395-a16c-8ed84b439080.webp',
//     desc: '[BD] Sony TV',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/sony_entertainment/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 2200
//   },

//   // News channels
//   {
//     id: 49,
//     name: 'DBC News HD',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1770186306600.png',
//     desc: 'DBC News HD',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1728/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 310
//   },
//   {
//     id: 50,
//     name: 'Ekattor HD',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1739963327549.png',
//     desc: 'Ekattor HD',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1705/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 650
//   },
//   {
//     id: 51,
//     name: 'Channel 24 HD',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1735556516924.png',
//     desc: 'Channel 24 HD',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1703/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 420
//   },
//   {
//     id: 52,
//     name: 'ATN News',
//     cat: 'news',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1739962961772.png',
//     desc: 'ATN News',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1706/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 378
//   },

//   // Kids channels
//   {
//     id: 53,
//     name: 'Cartoon Network HD +',
//     cat: 'kids',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/1y6e-JQBv9knK3AHNDWb/posters/ee9ba01b-1bcf-436b-b273-7b857f0810fb.webp',
//     desc: '[BD] Cartoon Network HD',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/cartoon_network_hd/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 870
//   },
//   {
//     id: 54,
//     name: 'POGO',
//     cat: 'kids',
//     icon: 'https://assets-prod.services.toffeelive.com/f_png,w_300,q_85/ny6W-JQBv9knK3AHujXC/posters/7e7c2afe-a663-4c09-983a-2d0fa0f1ca9a.webp',
//     desc: '[BD] POGO',
//     url: 'https://bldcmprod-cdn.toffeelive.com/cdn/live/pogo_sd/playlist.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 430
//   },

//   // Religious channels
//   {
//     id: 55,
//     name: 'Islamic TV',
//     cat: 'religious',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1772728412891.png',
//     desc: 'Islamic TV',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1724/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 490
//   },
//   {
//     id: 56,
//     name: 'Al Quran',
//     cat: 'religious',
//     icon: 'https://tstatic.akash-go.com/cms-ui/images/custom-content/1778086065071.png',
//     desc: 'Al Quran',
//     url: 'https://owrcovcrpy.gpcdn.net/bpk-tv/1713/output/index.m3u8',
//     type: 'hls',
//     status: 'live',
//     viewers: 350
//   }
];

export const categoryLabels = {
  all: 'সব চ্যানেল',
  worldcup: '🏆 World Cup 2026',
  sports: '⚽ Sports',
//   news: '📰 News',
//   entertainment: '🎬 Entertainment',
//   religious: '🕌 Religious',
//   kids: '👶 Kids',
//   movies: '🎥 Movies',
//   music: '🎵 Music',
//   infotainment: '📺 Infotainment'
};

export const categoryIcons = {
  worldcup: '🏆',
  sports: '⚽',
//   news: '📰',
//   entertainment: '🎬',
//   religious: '🕌',
//   kids: '👶',
//   movies: '🎥',
//   music: '🎵',
//   infotainment: '📺'
};